import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

//DigitalSignature
export const getCatalogs = () => api.get(`${url.catalogs}/types`);
export const getCatalogDescendent = (id: any) => api.get(`${url.catalogs}/descendants/${id}`);
export const getCatalogAncestors = (id: any) => api.get(`${url.catalogs}/ancestors/${id}`)
export const createCatalogs = (catalog: any) => api.create(url.catalogs, catalog)
export const updateCatalogs = (catalog: any, idCatalog: string) => api.put(`${url.catalogs}/${idCatalog}`, catalog);
export const deleteCatalogs = (id: any) => api.delete(`${url.catalogs}/${id}`);
